import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "condition", "inputUse", "onBlur", "onChange"];
import UIFormControl from 'UIComponents/form/UIFormControl';
import I18n from 'I18n';
import { getTransferableProps } from './filterInputProps';
import { fromSimpleDate, toSimpleDate } from 'customer-data-filters-ui/utils/momentSimpleDateConversion';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIDateRange from 'UIComponents/dates/UIDateRange';
import { useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorDateRangeInput = props => {
  const {
      error,
      condition,
      inputUse,
      onBlur,
      onChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [isOpen, setIsOpen] = useState(false);
  const fieldType = condition.field && condition.field.type;
  const onChangeLocal = evt => {
    const startDate = fromSimpleDate(fieldType, evt.target.value.startDate);
    const endDate = fromSimpleDate(fieldType, evt.target.value.endDate);
    onChange(syntheticEvent(condition.merge({
      value: startDate,
      highValue: endDate
    })));
  };
  const prevIsOpen = useRef(isOpen);
  useEffect(() => {
    if (isOpen === false && prevIsOpen.current === true && onBlur) {
      onBlur();
    }
    prevIsOpen.current = isOpen;
  }, [isOpen, onBlur]);
  const isError = error.get('error');
  const errorMessage = error.get('message');

  // @ts-expect-error we added types to `toSimpleDate` after this was written
  const startDate = toSimpleDate(fieldType, condition.get('value'));
  // @ts-expect-error we added types to `toSimpleDate` after this was written
  const endDate = toSimpleDate(fieldType, condition.get('highValue'));
  const inputValue = {
    startDate,
    endDate
  };
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest
  } = transferableProps;

  // @ts-expect-error allows us to avoid spreading props to UIComponents
  const disabled = transferableProps.disabled;
  // @ts-expect-error allows us to avoid spreading props to UIComponents
  const readOnly = transferableProps.readOnly;
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(UIDateRange, {
      "data-selenium-test": dataSeleniumTest,
      disabled: disabled,
      readOnly: readOnly,
      use: inputUse,
      onChange: onChangeLocal,
      onOpenChange: evt => setIsOpen(evt.target.value),
      value: inputValue
    })
  });
};
export default FilterOperatorDateRangeInput;